import * as Sentry from "@sentry/react-native";
import { logger } from "@/shared/lib/logger";

const log = logger.create("auth");

export const authTrace = {
  sessionStart() {
    log.info("session.load.start");
    return Sentry.startInactiveSpan({ name: "auth.session.load", op: "auth" });
  },
  sessionResolved(
    span: ReturnType<typeof Sentry.startInactiveSpan>,
    result: { hasSession: boolean; userId?: string }
  ) {
    span.setAttributes(result);
    span.setStatus({ code: 1 });
    span.end();
    log.info("session.load.resolved", result);
  },
  sessionError(
    span: ReturnType<typeof Sentry.startInactiveSpan>,
    error: unknown
  ) {
    span.setStatus({ code: 2, message: String(error) });
    span.end();
    log.error("session.load.failed", error);
  },
  sessionChangeStart(event: string) {
    log.info("auth state changed", { event });
    Sentry.addBreadcrumb({
      category: "auth",
      message: `→ ${event}`,
      level: "info",
    });
    return Sentry.startInactiveSpan({
      name: "auth.session.change",
      op: "auth",
      attributes: { event },
    });
  },

  profileStart(userId: string) {
    log.info("profile.load.start", { userId });
    return Sentry.startInactiveSpan({ name: "auth.profile.load", op: "auth" });
  },
  profileResolved(
    span: ReturnType<typeof Sentry.startInactiveSpan>,
    result: { outcome: "success" | "not-found" }
  ) {
    span.setAttributes(result);
    span.setStatus({ code: 1 });
    span.end();
    log.info("profile.load.resolved", result);
  },
  profileError(
    span: ReturnType<typeof Sentry.startInactiveSpan>,
    error: unknown,
    attempt: number
  ) {
    log.warn("profile.load.error", { attempt, error: String(error) });
    if (attempt >= 1) {
      span.setStatus({ code: 2, message: String(error) });
      span.end();
    }
  },
  splashHidden() {
    log.info("splash.hidden");
    Sentry.addBreadcrumb({
      category: "auth",
      message: "splash hidden",
      level: "info",
    });
  },
  navigated(destination: "tabs" | "auth" | "complete-profile" | "error") {
    log.info("navigation.target", { destination });
    Sentry.addBreadcrumb({
      category: "auth",
      message: `→ ${destination}`,
      level: "info",
    });
  },
};
